import { createFileRoute } from "@tanstack/react-router";
import AntidepressantsDontWorkPage from "@/pages/learn/AntidepressantsDontWorkPage";
import { pageAntidepressantsDontWork } from "@/pages/learn/learnDataAntidepressantsDontWork";
export const Route = createFileRoute("/learn/when-antidepressants-dont-work")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "When Antidepressants Don't Work: What Next? | Neuro Wellness",
        },
        {
          name: "description",
          content:
            "What to try when antidepressants aren't working: inadequate response, treatment-resistant depression, medication adjustments, psychotherapy, TMS, SAINT®.",
        },
        {
          property: "og:title",
          content:
            "When Antidepressants Don't Work: What Next? | Neuro Wellness",
        },
        {
          property: "og:description",
          content:
            "What to try when antidepressants aren't working: inadequate response, treatment-resistant depression, medication adjustments, psychotherapy, TMS, SAINT®.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/learn/when-antidepressants-dont-work",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/learn/when-antidepressants-dont-work",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(pageAntidepressantsDontWork.schemaJson),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <AntidepressantsDontWorkPage />;
}
